/* eslint-disable */
export default {
  logging: 'Connessione...',
  logCall: 'Registra chiamata',
  editLog: 'Modifica registro',
  select: 'Seleziona un record corrispondente',
  OnHold: 'In attesa',
  Ringing: 'Chiamata in arrivo',
  CallConnected: 'Chiamata connessa',
  unknownUser: 'Utente sconosciuto',
  unknownNumber: 'Anonimo',
  unavailable: 'Non disponibile',
  viewDetails: 'Visualizza dettagli',
  addEntity: 'Crea nuovo',
  addLog: 'Registro',
  text: 'SMS',
  call: 'Chiamata',
  addContact: 'Aggiungi contatto',
  missedCall: 'Persa',
  inboundCall: 'In entrata',
  outboundCall: 'In uscita',
  from: 'Da',
  to: 'A',
  hangup: 'Riaggancia',
  accept: 'Rispondi',
  toVoicemail: 'Alla segreteria telefonica',
  anonymous: 'Anonimo',
  mergeToConference: 'Unisci a chiamata attiva',
  hold: 'Metti in attesa',
  unhold: "Interrompi l'attesa",
  transfer: 'Trasferisci',
  reject: 'Rifiuta',
  switchCall: 'Passa chiamata su questa app',
  callSwitch: 'Commutazione chiamata',
  comfirmContext:
    'Al momento sei in una chiamata attiva con {displayName}. Vuoi continuare la chiamata su questo dispositivo?',
  comfirmCancelButton: 'Annulla',
  comfirmOKButton: 'Commuta',
  ignore: 'Ignora',
  holdAndAnswer: 'Metti in attesa e rispondi',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"addContact"@#@ @source: @#@"Add Contact"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"accept"@#@ @source: @#@"Answer"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"unhold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"switchCall"@#@ @source: @#@"Switch Call to this app"@#@
// @key: @#@"callSwitch"@#@ @source: @#@"Call Switch"@#@
// @key: @#@"comfirmContext"@#@ @source: @#@"You're currently on an active call with {displayName}. Would you like to continue the call on this device?"@#@
// @key: @#@"comfirmCancelButton"@#@ @source: @#@"Cancel"@#@
// @key: @#@"comfirmOKButton"@#@ @source: @#@"Switch"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
